export default __webpack_public_path__ + "static/titilliumweb-semibold-webfont-db6cb338878607a262a2c1a3fe98b83b.woff";